export class FloatingChartData {
    data: [number, number][] | undefined;
    label: string | undefined;
    maxBarThickness: number = 80 ;
  }
  